var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreasureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 29",
    style: {
      enableBackground: "new 0 0 30 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F5D89;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,3.8l-13.3,0l-6.8,7.8l13.6,16l13.6-16l-6.8-7.8H21.4z M21,5.6l2.5,5.1h-2.9l-2-5.1L21,5.6z M16.6,5.6 l1.3,5.1H12l1.3-5.1L16.6,5.6z M11.3,5.6l-2.4,5.1H6.2l-1.1,0.9l0.7,0.7l3,0.1l3.6,9.3L3.8,11.6l5.2-6L11.3,5.6z M12,12.5l5.9,0.2 L15,24.4L12,12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasureIcon);
export default __webpack_public_path__ + "static/media/treasure-icon.ffe67ef5edcadcb347e40a7d2b88a360.svg";
export { ForwardRef as ReactComponent };